export default __webpack_public_path__ + "static/media/GIMP.5432efcc.png";